export enum AccountApiUrls {
    Login= "/api/Account/Login",
    RefreshToken= "/api/Account/RefreshToken"
}
